// extracted by mini-css-extract-plugin
export default {"notSetup":"notsetup_notSetup__xv3R1"};